import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import Welcome from "./Home/Welcome";
import Profile from "./Home/Profile";
import Home from "./Home/Home";
import Contact from "./Home/Contact";
import MyAccount from "./Home/MyAccount";

import NewLogin from "./Login/NewLogin";

import Login from "./Login/Login";
import Setpassword from "./Login/Setpassword";
import Pricing from "./Membership/Pricing";
import RegisterOption from "./Membership/RegisterOption";
import CompanyRegister from "./Membership/CompanyRegister";
import { useTranslation } from 'react-i18next';

import MembershipForm from "./Membership/MembershipForm";
//import Tabs from "./Membership/Tabs";

import Register from "./Login/Register";
import Validate from "./Login/Validate";
import Dashboard from "./Home/Dashboard";
import CreateEvent from "./Home/CreateEvent";
import EventDetails from "./Home/EventDetails";
import UserProfile from "./Dashboard/UserProfile";

import Venue from "./Home/Venue";

import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'; 
import Navbar from "./Components/Navbar";
import ProtectedRoute from "./Utils/ProtectedRoute";
import CompanyRoute from "./Utils/ProtectedRoute";
import './i18n';
// import I18n from "redux-i18n"
// // with Immutable.js:
// import I18n from "redux-i18n/immutable"
 
import {translations} from "./translations"


class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
        <Switch> 
          <Route exact path='/' component={Welcome}></Route> 
          <Route exact path='/register' component={Login}></Route> 
          <Route exact path='/validate' component={Validate}></Route> 
          <Route exact path='/setpassword' component={Setpassword}></Route> 
          <Route exact path='/options' component={RegisterOption}></Route> 
          <Route exact path='/companyregister' component={CompanyRegister}></Route> 
          <Route exact path='/contact' component={Contact}></Route> 
          <Route exact path='/welcome' component={Welcome}></Route> 
          <ProtectedRoute exact path='/myaccount' component={UserProfile}></ProtectedRoute> 
          <ProtectedRoute exact path='/createevent' component={CreateEvent}></ProtectedRoute> 

          <ProtectedRoute path='/profile' component={UserProfile} />
          <Route exact path='/home' component={Home}></Route>
          <ProtectedRoute exact path='/dash' component={Dashboard}></ProtectedRoute> 
          <ProtectedRoute exact path='/details' component={EventDetails}></ProtectedRoute> 

          <Route exact path='/venue' component={Venue}></Route> 
         // <Route exact path='/register' component={Login}></Route> 
          <Route exact path='/login' component={NewLogin}></Route> 

          <Route exact path='/newlogin' component={NewLogin}></Route> 

          <ProtectedRoute exact path='/pricing' component={Pricing}></ProtectedRoute> 
          {/* <Route exact path='/membership' component={MembershipForm}></Route>  */}
          <ProtectedRoute exact path='/membership' component={MembershipForm}></ProtectedRoute> 
        </Switch> 
        </Router>
      </div>
    );
  }
}

export default App;
